/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AvailableLegalNoticesAttributeType } from './';
import {
    AvailableLegalNoticesAttributeTypeFromJSON,
    AvailableLegalNoticesAttributeTypeFromJSONTyped,
    AvailableLegalNoticesAttributeTypeToJSON,
} from './';
import type { CompanyTypeView } from './';
import {
    CompanyTypeViewFromJSON,
    CompanyTypeViewFromJSONTyped,
    CompanyTypeViewToJSON,
} from './';
import type { CompanyTypesResponseCountriesInner } from './';
import {
    CompanyTypesResponseCountriesInnerFromJSON,
    CompanyTypesResponseCountriesInnerFromJSONTyped,
    CompanyTypesResponseCountriesInnerToJSON,
} from './';
import type { CountryView } from './';
import {
    CountryViewFromJSON,
    CountryViewFromJSONTyped,
    CountryViewToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTypesResponse
 */
export interface CompanyTypesResponse {
    /**
     * 
     * @type {Array<AvailableLegalNoticesAttributeType>}
     * @memberof CompanyTypesResponse
     */
    availableLegalNoticesAttributeTypes: Array<AvailableLegalNoticesAttributeType>;
    /**
     * 
     * @type {CountryView}
     * @memberof CompanyTypesResponse
     */
    country: CountryView;
    /**
     * 
     * @type {Array<CompanyTypeView>}
     * @memberof CompanyTypesResponse
     */
    legals: Array<CompanyTypeView>;
    /**
     * Types from the parent/mainland country when the requested country is a regional code (e.g. GP → FR types)
     * @type {Array<CompanyTypeView>}
     * @memberof CompanyTypesResponse
     */
    mainlandTypes?: Array<CompanyTypeView>;
    /**
     * 
     * @type {Array<CompanyTypesResponseCountriesInner>}
     * @memberof CompanyTypesResponse
     */
    countries: Array<CompanyTypesResponseCountriesInner>;
}

/**
 * Check if a given object implements the CompanyTypesResponse interface.
 */
export function instanceOfCompanyTypesResponse(value: object): value is CompanyTypesResponse {
    if (!('availableLegalNoticesAttributeTypes' in value) || value['availableLegalNoticesAttributeTypes'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('legals' in value) || value['legals'] === undefined) return false;
    if (!('countries' in value) || value['countries'] === undefined) return false;
    return true;
}

export function CompanyTypesResponseFromJSON(json: any): CompanyTypesResponse {
    return CompanyTypesResponseFromJSONTyped(json, false);
}

export function CompanyTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'availableLegalNoticesAttributeTypes': ((json['availableLegalNoticesAttributeTypes'] as Array<any>).map(AvailableLegalNoticesAttributeTypeFromJSON)),
        'country': CountryViewFromJSON(json['country']),
        'legals': ((json['legals'] as Array<any>).map(CompanyTypeViewFromJSON)),
        'mainlandTypes': json['mainlandTypes'] == null ? undefined : ((json['mainlandTypes'] as Array<any>).map(CompanyTypeViewFromJSON)),
        'countries': ((json['countries'] as Array<any>).map(CompanyTypesResponseCountriesInnerFromJSON)),
    };
}

export function CompanyTypesResponseToJSON(value?: CompanyTypesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'availableLegalNoticesAttributeTypes': ((value['availableLegalNoticesAttributeTypes'] as Array<any>).map((v) => AvailableLegalNoticesAttributeTypeToJSON(v))),
        'country': CountryViewToJSON(value['country']),
        'legals': ((value['legals'] as Array<any>).map((v) => CompanyTypeViewToJSON(v))),
        'mainlandTypes': value['mainlandTypes'] == null ? undefined : ((value['mainlandTypes'] as Array<any>).map((v) => CompanyTypeViewToJSON(v))),
        'countries': ((value['countries'] as Array<any>).map((v) => CompanyTypesResponseCountriesInnerToJSON(v))),
    };
}

